export default "__VITE_ASSET__120c5218__"